/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAnnouncementDto } from '../../models/platform-api-result-of-announcement-dto';
import { PlatformUpdateAnnouncement } from '../../models/platform-update-announcement';

export interface PutNotificationsAnnouncements$Params {
      body: PlatformUpdateAnnouncement
}

export function putNotificationsAnnouncements(http: HttpClient, rootUrl: string, params: PutNotificationsAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
  const rb = new RequestBuilder(rootUrl, putNotificationsAnnouncements.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAnnouncementDto>;
    })
  );
}

putNotificationsAnnouncements.PATH = '/api/notifications/announcements';
